<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        persistent
        max-width="700"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="wrapperFormModal">
                <v-card
                    flat
                >
                    <v-card-text>

                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">{{ $t("Наименование_каз") }}</label>
                            </v-col>

                            <v-col cols="12" sm="12" md="9">
                                <div v-if="!options.allowEdit" class="onlyReadData">
                                    {{ options.requisiteGroup.UniValue['kk-KZ'] }}
                                </div>
                                <v-text-field
                                    v-else
                                    v-model.trim="options.requisiteGroup.UniValue['kk-KZ']"
                                    hide-details
                                    required
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="3">
                                <label class="f-label">{{ $t("Наименование_рус") }}</label>
                            </v-col>

                            <v-col cols="12" sm="12" md="9">
                                <div v-if="!options.allowEdit" class="onlyReadData">
                                    {{ options.requisiteGroup.UniValue['ru-RU'] }}
                                </div>
                                <v-text-field
                                    v-else
                                    v-model.trim="options.requisiteGroup.UniValue['ru-RU']"
                                    hide-details
                                    required
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        
                    </v-card-text>

                </v-card>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    v-if="isValidForSave"
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                >
                    {{ $t("Сохранить") }}
                </v-btn>

                <v-btn 
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Закрыть") }}
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "CreateRequisitesGroupDlg",
    data: () => ({
        title: "Группа_реквизитов",
        visible: false,
        resolve: null,
        options: {
            requisiteGroup: null,
            allowEdit: false
        },
    }),
    computed: {
        isValidForSave() {
            return this.options.requisiteGroup.UniValue['kk-KZ']
                && this.options.requisiteGroup.UniValue['ru-RU']
                && this.options.allowEdit;
        }
    },
    methods: {
        async open(options = {}) {
            this.reset();
            this.visible = true;
            this.options = Object.assign(this.options, options);

            if (!this.options.requisiteGroup)
                this.options.requisiteGroup = this.getNewRequisitesGroup();

            return new Promise((resolve) => { this.resolve = resolve; });
        },
        ok() {
            this.visible = false;
            this.resolve({ action: 'save', object: { __type: "Reference:#Avrora.Objects.Ref", ...this.options.requisiteGroup } });
        },
        cancel() {
            this.visible = false;
            this.resolve({ action: 'cancel', object: null });
        },
        reset() {
            this.options.requisiteGroup = null;
            this.options.allowEdit = false;
        },
        getNewRequisitesGroup() {
            return {
                is_new_record: true,
                ReferenceType: 1042,
                UniValue: { 'kk-KZ': null, 'ru-RU': null }
            };
        }
    }
}
</script>